// Attached files stay in the browser until the text is sent; the markdown
// points at each one by a blob URL, and this is how the URL finds its file.
const files = new Map<string, File>();

export function attachFile(file: File): string {
  const url = URL.createObjectURL(file);
  files.set(url, file);
  return url;
}

const BLOB_URL = /\]\((blob:[^)\s]+)\)/g;

// In the order the text mentions them, each file once.
export function attachedFilesIn(markdown: string): Array<{ url: string; file: File }> {
  const found = new Map<string, File>();
  for (const [, url] of markdown.matchAll(BLOB_URL)) {
    const file = files.get(url);
    if (file && !found.has(url)) found.set(url, file);
  }
  return [...found].map(([url, file]) => ({ url, file }));
}
